import React from 'react'

import PageHeader from '../components/PageHeader'
import PageSection from '../components/PageSection'
import Button from '../components/Button'
// import Carousel from '../components/Carousel'

import TestimonialsCarousel from '../components/TestimonialsCarousel'
import AnimatedMetrics from '../components/AnimatedMetrics'

import { METRICS_AI } from './AirstreamPage'

const STORY_SECTION_ILLUSTRATIONS = [
  'mediakit/microphone',
  'mediakit/radio',
  'airstream/van',
  'mediakit/coffee-machine',
  'mediakit/hotel',
  'mediakit/city'
]

const METRICS_PRIVACY = [
  {
    metric: '92',
    metricSuffix: '%',
    text: 'Of those surveyed want to control the way their data is used.',
    reference: {
      label: 'Snips 2018 Survey'
    }
  },
  {
    metric: '68',
    metricSuffix: '%',
    text: 'Said privacy is more important to them than convenience.',
    reference: {
      label: 'Snips 2018 Survey'
    }
  },
  {
    metric: '30',
    metricSuffix: '%',
    text:
      'Believe their favorite consumer brands are doing enough to protect their personal data.',
    reference: {
      label: 'Snips 2018 Survey'
    }
  }
]

/* const MediaKitSliderItem = ({ content }) => (
  <div className='mediakit-page__hero-section__carousel__item overflow-hidden'>
    {content}
  </div>
) */

function StoryList ({ items }) {
  return (
    <ul className='mediakit-page__story-section__list mb3 pb4 col-10 lg-col-9 mx-auto'>
      {items.map(({ title, content }, idx) => (
        <li
          key={idx}
          className='mediakit-page__story-section__list-item mb4 p1'
        >
          <img
            className='mediakit-page__story-section__list-item__img mb2'
            src={`/static/images/${STORY_SECTION_ILLUSTRATIONS[idx]}.svg`}
          />
          <p className='mediakit-page__story-section__list-item__first-line h3 mb3'>
            {title}
          </p>
          <p className='text-para'>{content}</p>
        </li>
      ))}
    </ul>
  )
}

export const AirstreamMediakitPage = ({
  data: {
    acf: {
      heroTitleFirstLine,
      heroTitleSecondLine,
      heroContent,

      storySectionTitle,
      storySectionItems,

      testimonialSlides
    }
  }
}) => (
  <main className='main mediakit-page maxw-xxlarge mx-auto'>
    <PageHeader extraClass='mediakit-page__header bg-white' title={null}>
      <h1 className='mediakit-page__hero-section__title mb2'>
        <div className='mediakit-page__hero-section__title--big strong'>
          {heroTitleFirstLine}
        </div>
        {heroTitleSecondLine && (
          <span className='mediakit-page__hero-section__title--small bold mr1'>
            {heroTitleSecondLine}
          </span>
        )}
      </h1>
      <div className='mediakit-page__hero-section__content'>
        <div
          className='text-para small mb2'
          dangerouslySetInnerHTML={{ __html: heroContent }}
        />
      </div>
      <div className='mediakit-page__hero-section__images overflow-hidden col-12 sm-col-10 md-col-8 lg-col-12 mx-auto mb3 py3'>
        {/* temporary replace carousel */}
        <img
          className='mediakit-page__hero-section__image'
          src='/static/images/mediakit/airstream-night.jpg'
        />
        {/*
        <Carousel
          extraClass={'mediakit-page__hero-section__carousel'}
          sliderOptions={{
            slidesToShow: 1,
            initialSlide: 1,
            infinite: false,
            dots: true,
            autoplay: false
          }}
          slides={Array(3).fill({
            content: (
              <img src='https://placeholdit.co//i/680x450?text=airstream&bg=b0b4d1' />
            )
          })}
          slideRenderFn={MediaKitSliderItem}
        /> */}
      </div>
      <p className='text-para text-para--dark bold mb3'>
        For more information email{' '}
        <a href='mailto:airstream@snips.ai'>airstream@snips.ai</a>
      </p>
      <div className='flex flex-column items-center'>
        <div className='mediakit-page__hero-section__actions mb4'>
          <Button
            className='mediakit-page__hero-section__actions__button button button--secondary full-width mb2'
            href='/static/snips-airstream-mediakit.zip'
            download
          >
            Download Media Kit
          </Button>
          <Button
            href='/airstream'
            className='mediakit-page__hero-section__actions__button button button--outline'
          >
            Visit the Website
          </Button>
        </div>
      </div>
    </PageHeader>

    <PageSection extraClass='mediakit-page__story-section page-section--tiny center'>
      <h2 className='mediakit-page__story-section__title flex justify-center items-center h2 mx-auto'>
        {storySectionTitle}
      </h2>
      {storySectionItems && <StoryList items={storySectionItems} />}
    </PageSection>

    <PageSection extraClass='mediakit-page__metrics-section white'>
      <h2 className='h2 mb4 center'>Why Privacy Matters</h2>
      <AnimatedMetrics
        items={[...METRICS_PRIVACY, ...METRICS_AI]}
        onTopOfDarkBg
      />
    </PageSection>

    <PageSection extraClass='mediakit-page__testimonials-section bg-white'>
      {testimonialSlides && (
        <TestimonialsCarousel
          slides={testimonialSlides}
          extraClass='mediakit-page__testimonials-section__carousel lg-col-8 mx-auto overflow-hidden mb4'
        />
      )}
    </PageSection>
  </main>
)

export default AirstreamMediakitPage



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/AirstreamMediakitPage.js